import { httpsCallable } from 'firebase/functions';
import { anonymousAuthReady, auth, functions } from '../firebaseConfig';
import { openPublishSessionForWallet } from './auth';

const saveUsername = httpsCallable(functions, 'setWalletUsername');

export async function setWalletUsername(wallet, muultiName, { isCurrent = () => true } = {}) {
    const uid = wallet?.publicKey?.toBase58?.();
    const adapter = wallet?.wallet?.adapter || wallet?.adapter || wallet;
    let sessionOpened = false;
    const assertCurrent = () => {
        if (!uid || !isCurrent() || adapter?.connected === false ||
            adapter?.publicKey?.toBase58?.() !== uid) {
            throw new Error('Wallet changed. Please retry with your current wallet.');
        }
    };
    const openVerifiedSession = async () => {
        await openPublishSessionForWallet(wallet, 'us-central1', { isCurrent });
        sessionOpened = true;
        assertCurrent();
        if (auth.currentUser?.uid !== uid) throw new Error('Sign in with your connected wallet first.');
        await auth.currentUser.getIdTokenResult?.(true);
        assertCurrent();
    };
    assertCurrent();
    await anonymousAuthReady;
    assertCurrent();
    const token = auth.currentUser?.uid === uid ? await auth.currentUser.getIdTokenResult() : null;
    if (token?.claims?.walletVerified !== true) {
        await openVerifiedSession();
    }
    assertCurrent();
    if (auth.currentUser?.uid !== uid) throw new Error('Sign in with your connected wallet first.');
    const payload = { publicKey: uid, muultiName: muultiName.trim() };
    try {
        return (await saveUsername(payload)).data;
    } catch (err) {
        if (sessionOpened || !String(err?.code || '').endsWith('unauthenticated')) throw err;
        await openVerifiedSession();
        return (await saveUsername(payload)).data;
    }
}
